// src/components/ManifestItemCard.jsx
import { useRef } from "react";
import { PaperDarkBG, PaperBG, PaperGoldBG, PaperGradientBG } from "../DesignKit";
import RoughBorder from "../LayoutKit/RoughBorder";

const ManifestItemCard = ({ id, title, text, usePaperBG = false }) => {
  const cardRef = useRef();

  return (
    <div
      ref={cardRef}
      className={`
        relative
        h-auto sm:h-48
        flex flex-col
        ${usePaperBG ? '' : ' bg-gradient-to-br from-[#FAF6F1] to-[#F5EFE7]'}

        rounded-xl
        p-4 sm:p-6
        shadow-md

      font-mono
        max-w-full sm:max-w-4xl mx-auto space-y-2
      `}
      style={usePaperBG ? {
       
        backgroundColor: "#F5EFE7",
      
      } : {}}

    >
      {/* ID */}
      <div className="text-xs sm:text-sm font-semibold text-gray-800 px-2">
        {id}
      </div>

      {/* Titel */}
      <PaperGradientBG className="rounded-lg overflow-hidden">
        <p className="
          text-xs sm:text-xs text-white
          leading-tight pt-3 pb-2 px-3 rounded-md line-clamp-2
        ">
          {title}
        </p>
      </PaperGradientBG>

      {/* Fließtext */}
      <p className="
        flex-grow text-xs sm:text-xs text-gray-700 leading-relaxed px-3
      ">
        {text}
      </p>

      {/* RoughBorder als Außenrahmen */}
      <RoughBorder
        parentRef={cardRef}
          radius={18}
          padding={2}
          color="#AC8E66" 
          strokeWidth={0.3}
          roughness={1.1}
          bowing={2}
   
      />
    </div>
  );
};

export default ManifestItemCard;
